<template>
  <NuxtLink :to="gameLink" class="flex items-center justify-between relative">
    <div class="space-y-1">
      <div class="flex gap-1 items-center md:text-lg">
        <div class="w-6 md:w-8 aspect-square">
          <TeamLogo class="block w-full h-full" :name="game.home.name" :slug="game.home.slug" :logo="game.home.logo" size="64" :alt="game.home.abbr" />
        </div>
        <div class="font-bold line-clamp-1">{{ game.home.name }}</div>
      </div>
      <div class="flex gap-1 items-center md:text-lg">
        <div class="w-6 md:w-8 aspect-square">
          <TeamLogo class="block w-full h-full" :name="game.away.name" :slug="game.away.slug" :logo="game.away.logo" size="64" :alt="game.away.abbr" />
        </div>
        <div class="font-bold line-clamp-1">{{ game.away.name }}</div>
      </div>
    </div>
    <div class="flex items-center gap-4">
      <div class="w-8 text-xs text-slate-700 bg-slate-200 text-center rounded py-1" v-if="game.result?.status === 'ft'">
        FT
      </div>
      <div class="space-y-1 font-bold md:text-lg" v-if="useDate().isAfter(game.startDate)">
        <div class="h-6 md:h-8 w-8 flex items-center justify-center">
          {{ game.result?.home }}
        </div>
        <div class="h-6 md:h-8 w-8 flex items-center justify-center">
          {{ game.result?.away }}
        </div>
      </div>
      <div class="text-center w-12 md:w-16" v-else>
        <div class="text-slate-500">{{ useDate(game.startDate).format('HH:mm') }}</div>
      </div>
    </div>
    <div class="absolute -right-1 w-1 h-full" v-if="game.result?.status === 'ft' && outcome">
      <div class="w-full h-full rounded bg-green-500" v-if="outcome === 'win'"></div> 
      <div class="w-full h-full rounded bg-red-500" v-if="outcome === 'loss'"></div> 
      <div class="w-full h-full rounded bg-slate-300" v-if="outcome === 'draw'"></div> 
    </div>
  </NuxtLink>
</template>

<script setup>
const route = useRoute()
const user = useUserStore()
const team = useTeamStore()

const props = defineProps({
  game: {
    type: Object,
    default: () => []
  }
})

// Game link (this should probably be handled a different way in the future)
const gameLink = computed(() => {
  if (route.params?.team) {
    return { name: 'team-game', params: { team: route.params?.team, game: props.game.slug }}
  }

  if (route.params?.league || props.game?.league.slug) {
    return { name: 'leagues-league-game', params: { league: props.game?.league.slug, game: props.game.slug }}
  }
})

// Check if user is viewing generic routes, or a team route
const outcomeTeamSlug = computed(() => {
  if (route.params?.team) {
    return route.params?.team
  }

  return user.favorite?.slug
})

// Select outcome from team and result
const outcome = computed(() => {
  const isFinalTime = props.game.result?.status === 'ft'
  const isTeamIncluded = [props.game.home.slug, props.game.away.slug].includes(outcomeTeamSlug.value)
  if (!isFinalTime || !isTeamIncluded) return null 

  const result = props.game.result
  const isHomeTeam = team.slug === props.game.home.slug
  const teamGoals = isHomeTeam ? result.home : result.away
  const opponentGoals = isHomeTeam ? result.away : result.home

  if (teamGoals > opponentGoals) return 'win'
  if (teamGoals < opponentGoals) return 'loss'
  return 'draw'
})
</script>